import { Input } from 'antd';
import { TextAreaProps } from 'antd/es/input';

import { FC } from 'react';

import { PlaceholderAsLabel } from '~shared/ui/layout';

export const TextArea: FC<TextAreaProps> = ({ size = 'large', placeholder, value, ...props }) => {
  return (
    <PlaceholderAsLabel placeholder={placeholder} value={value}>
      <Input.TextArea {...props} placeholder={placeholder} value={value} />
    </PlaceholderAsLabel>
  );
};
